import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useFetchComputeCapacity, useUpdateComputeCapacity } from 'hooks/questionAPIs';


const useCapacityManagement = ({
  crId, crqId, questionId, question,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const [currVal, setCurrVal] = useState(null);
  const [initialVal, setInitialVal] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    data,
    isSuccess: isFetchSuccess,
    isFetching,
  } = useFetchComputeCapacity(questionId, crqId);

  const {
    isLoading: isCapacityUpdating,
    isSuccess: isCapacityUpdated,
    mutate: updateCapacity,
  } = useUpdateComputeCapacity();

  useEffect(() => {
    // Only initialize once to prevent overwriting user changes
    if (isInitialized) return;

    if (questionId) {
      if (isFetchSuccess && !isFetching) {
        const fetched = data?.computeCapacity;
        const value = fetched || question?.computeCapacity || 'DEFAULT';
        setCurrVal(value);
        setInitialVal(value);
        setIsInitialized(true);
      }
    }
    else {
      const value = question?.computeCapacity || 'DEFAULT';
      setCurrVal(value);
      setInitialVal(value);
      setIsInitialized(true);
    }
  }, [data, isFetchSuccess, isFetching, question?.computeCapacity, questionId, isInitialized]);

  const saveCapacity = () => {
    updateCapacity({
      questionID: questionId,
      payload: {
        organizationID: orgId,
        cleanRoomID: crId,
        cleanRoomQuestionID: crqId,
        computeCapacity: currVal,
      },
    }, {
      onSuccess: () => {
        dispatch(showAlert({ message: `Processing capacity updated for "${data.questionTitle}"`, type: 'success' }));
      },
    });
  };

  return {
    isCapacityUpdating,
    isCapacityUpdated,
    currVal,
    setCurrVal,
    saveCapacity,
    initialVal,
  };
};

export default useCapacityManagement;
